import React from 'react';
import { motion } from 'framer-motion';
import { FaPhone, FaMapMarkerAlt, FaQrcode, FaClock, FaEnvelope } from 'react-icons/fa';
import content from '../config/content.json';

function Contact() {
  const { address, phones, mapDirectLink, coordinates, email } = content.contact;

  // Use local QR code image
  const qrCodeUrl = `${process.env.PUBLIC_URL}/photos/qr_code_gmaps.jpeg`;

  // Generate proper embed URL with coordinates
  const mapEmbedUrl = `https://www.google.com/maps?q=${coordinates.lat},${coordinates.lng}&hl=en&z=15&output=embed`;

  return (
    <div className="contact-page">
      <section className="page-header">
        <div className="container">
          <motion.h1
            initial={{ opacity: 0, y: -30 }}
            animate={{ opacity: 1, y: 0 }}
          >
            Get in Touch
          </motion.h1>
          <p>We're here to help you find your perfect accommodation</p>
        </div>
      </section>

      <section className="contact-content">
        <div className="container">
          <div className="contact-grid">
            <motion.div 
              className="contact-info"
              initial={{ opacity: 0, x: -50 }}
              animate={{ opacity: 1, x: 0 }}
            >
              <h2>Contact Information</h2>
              
              <div className="info-item">
                <div className="icon">
                  <FaMapMarkerAlt />
                </div>
                <div className="details">
                  <h3>Address</h3>
                  <p className="highlight">{content.siteInfo.name}</p>
                  <p className="subtitle">(Boys Only)</p>
                  <p>{address.line1}</p>
                  <p>{address.line2}</p>
                  <p>{address.line3}</p>
                  <p>{address.line4}</p>
                  <p className="city">{address.city} - {address.pincode}</p>
                </div>
              </div>

              <div className="info-item">
                <div className="icon">
                  <FaPhone />
                </div>
                <div className="details">
                  <h3>Phone Numbers</h3>
                  <p className="phone-info">Call us for inquiries and bookings</p>
                  {phones.map((phone, index) => (
                    <p key={index} className="phone-number">
                      <a href={`tel:${phone.replace(/\s/g, '')}`}>📞 {phone}</a>
                    </p>
                  ))}
                </div>
              </div>

              <div className="info-item">
                <div className="icon">
                  <FaEnvelope />
                </div>
                <div className="details">
                  <h3>Email</h3>
                  <p className="email-info">Send us your queries via email</p>
                  <p className="email-address">
                    <a href={`mailto:${email}`}>✉️ {email}</a>
                  </p>
                </div>
              </div>

              <div className="info-item visiting-hours-card">
                <div className="icon">
                  <FaClock />
                </div>
                <div className="details">
                  <h3>Visiting Hours</h3>
                  <p className="hours-highlight">Monday - Saturday</p>
                  <p className="time">9:00 AM - 6:00 PM</p>
                  <p className="note">💡 Call ahead to schedule your visit</p>
                </div>
              </div>
            </motion.div>

            <motion.div 
              className="contact-map-section"
              initial={{ opacity: 0, x: 50 }}
              animate={{ opacity: 1, x: 0 }}
            >
              <h2>Find Us on Map</h2>
              <div className="map-container">
                <iframe
                  src={mapEmbedUrl}
                  width="100%"
                  height="400"
                  style={{ border: 0 }}
                  allowFullScreen=""
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                  title="Thendral Mansion Location"
                ></iframe>
              </div>

              <motion.div 
                className="qr-section"
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
              >
                <div className="qr-header">
                  <FaQrcode className="qr-icon" />
                  <h3>Quick Navigation</h3>
                </div>
                <p className="qr-description">Scan to get instant directions</p>
                <div className="qr-code-container">
                  <a href={mapDirectLink} target="_blank" rel="noopener noreferrer">
                    <div className="qr-wrapper">
                      <img src={qrCodeUrl} alt="QR Code for Location" />
                      <div className="qr-overlay">
                        <span>📱 Tap to Open</span>
                      </div>
                    </div>
                  </a>
                  <p className="qr-note">
                    <span className="icon">📍</span>
                    Opens in Google Maps
                  </p>
                </div>
              </motion.div>
            </motion.div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default Contact;
